import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import { useRecoilValue } from "recoil";
import { loginState } from "../../stores/loginState";

// 수동 등록 송장 파일 업로드 API
export const useUploadManualScanFile = () => {
  const login = useRecoilValue(loginState);

  const mutation = useMutation((formData) => {
    if (login.company === "LOGEN") {
      return LogenInstance.post("/manual-scan-files", formData);
    }

    if (login.company === "LOTTE") {
      return LotteInstance.post("/manual-scan-files", formData);
    }

    return Promise.reject(new Error("Invalid company"));
  });

  return mutation;
};
